import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ProcessDialogModule } from 'app/main/content/processes/process-dialog/process-dialog.module';
import { SubjectStopwatchService } from './subject-stopwatch.service';

@NgModule({
    declarations: [],
    imports     : [ ProcessDialogModule, MatDialogModule ],
    exports     : [],
    providers   : [ SubjectStopwatchService ],
})
export class SubjectStopwatchModule
{
}
